import  { useState, useEffect } from 'react';
import Pagination from '@mui/material/Pagination';
import { API_URLS } from '../../apiUrl';
import axiosInstance from '../../components/axiosInstance';

const OccupancyType = () => {
    const [tableData, setTableData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    const [inputData, setInputData] = useState({ page: 1, limit: 50 });
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage] = useState(50);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.post(
                    `${API_URLS.OccupancyTypeList}`,
                    {
                        page: inputData.page,
                        limit: inputData.limit
                    }
                );

                if (response.data && response.data.data) {
                    setTableData(response.data.data.data);
                    setTotalItems(response.data.data.total);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [inputData.page]);

    const filteredData = tableData.filter((item: any) =>
        item.occupancy_type?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.status.toString().includes(searchQuery.toLowerCase())
    );

    const handlePageChange = (event: any, value: number) => {
        setInputData((prevData) => ({
            ...prevData,
            page: value,
        }));
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
        <div className="container mx-auto">
            <div className="flex gap-5 mb-4">
                <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Occupancy Type List</h1>

                <div className="flex justify-end md:w-4/12 w-full ml-auto">
                    <input
                        type="text"
                        placeholder="Search..."
                        className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
            </div>

            <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
                <table className="min-w-full table-auto">
                    <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
                        <tr>
                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Occupancy Type</th>
                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Created At</th>
                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Updated At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={3} className="py-3 px-6 text-center">Loading...</td>
                            </tr>
                        ) : filteredData.length === 0 ? (
                            <tr>
                                <td colSpan={3} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
                            </tr>
                        ) : (
                            filteredData.map((item: any, index) => (
                                <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.occupancy_type || 'N/A'}</td>
                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                        {item.created_at ? new Date(item.created_at).toLocaleString() : new Date().toLocaleString()}
                                    </td>
                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                        {item.updated_at ? new Date(item.updated_at).toLocaleString() : new Date().toLocaleString()}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {filteredData?.length === 0 ? null :
            <div className="flex justify-center mt-4">
                <Pagination
                    count={totalPages}
                    page={inputData.page}
                    onChange={handlePageChange}
                    color="primary"
                />
            </div>}
        </div>
    );
};

export default OccupancyType;